<template>
  <v-container>
    <div v-if="loginUser" class="mt-12">
      <v-card class="mx-auto" max-width="400">
        <v-img
          contain
          class="black--text align-end"
          height="125px"
          src="~/img/wiom_logo.png"
        >
          <v-card-title v-show="false">WIOM</v-card-title>
        </v-img>
        <v-card-subtitle class="pb-0"
          >Welcome to WIOM Portal</v-card-subtitle
        >
        <v-card-text class="text--primary">
          <div>Use your Username and Password to continue</div>
        </v-card-text>
        <v-text-field
          v-model="userName"
          label="User Name"
          class="mx-2"
          color="#214294"
          height="40px"
        ></v-text-field>
        <v-btn
          :text="true"
          style="
            position: relative;
            top: -20px;
            font-weight: 400;
            text-transform: capitalize;
            padding: 0px 5px 0px 5px;
          "
          small
          @click="show('forgot-username')"
          >Forgot Username?</v-btn
        >
        <v-text-field
          v-model="password"
          label="Password"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass ? 'text' : 'password'"
          @click:append="showPass = !showPass"
          class="mx-2"
          color="#214294"
          height="40px"
        ></v-text-field>
        <v-btn
          :text="true"
          style="
            position: relative;
            top: -20px;
            font-weight: 400;
            text-transform: capitalize;
            padding: 0px 5px 0px 5px;
          "
          small
          @click="show('forgot-password')"
          >Forgot Password?</v-btn
        >
        <v-card-actions>
          <v-btn color="#f26547" text @click="LoginUser(userName, password)"
            >Login</v-btn
          >
          <v-btn color="orange" text @click="clear">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-if="forgotUsername">
      <v-card class="mx-auto" max-width="400" style="padding-top: 30px">
        <v-img
          contain
          class="black--text align-end"
          style="margin: 0px auto; margin-top: 35px; margin-bottom: 35px;"
          width="250px"
          src="~/img/wiom_logo.png"
        ></v-img>
        <v-card-subtitle
          class="pb-0"
          style="font-weight: bold; font-size: 22px; color: #000"
          >Get Username</v-card-subtitle
        >
        <v-text-field
          v-model="nasid"
          label="Enter your device code"
          class="mx-2"
          color="#214294"
          height="40px"
          type="number"
          style="padding: 0px 10px 0px 10px"
        ></v-text-field>
        <v-card-actions
          style="position: relative; right: 0px; margin-top: 150px"
        >
          <v-spacer></v-spacer>
          <v-btn color="gray" text @click="close('forgot-username')"
            >CANCEL</v-btn
          >
          <v-btn
            id="submit"
            text
            @click="recover('username', nasid)"
            :disabled="nasid == null || (nasid && nasid < 1)"
            >SUBMIT</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
    <div v-if="forgotPassword">
      <v-card class="mx-auto" max-width="400" style="padding-top: 30px">
        <v-img
          contain
          class="black--text align-end"
          style="margin: 0px auto; margin-top: 35px; margin-bottom: 35px;"
          width="250px"
          src="~/img/wiom_logo.png"
        ></v-img>
        <v-card-subtitle
          class="pb-0"
          style="font-weight: bold; font-size: 22px; color: #000"
          >Get Password</v-card-subtitle
        >
        <v-text-field
          v-model="username"
          label="Enter your username"
          class="mx-2"
          color="#214294"
          height="40px"
          type="number"
          style="padding: 0px 10px 0px 10px"
        ></v-text-field>
        <v-card-actions
          style="position: relative; right: 0px; margin-top: 150px"
        >
          <v-spacer></v-spacer>
          <v-btn color="gray" text @click="close('forgot-password')"
            >CANCEL</v-btn
          >
          <v-btn
            id="submit"
            text
            @click="recover('password', username)"
            :disabled="username == null || username.length != 10"
            >SUBMIT</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="usernameRecoverySuccessful" persistent max-width="320">
      <v-card style="padding-top: 100px">
        <v-card-text style="text-align: center">
          <span style="font-weight: bold; font-size: 18px; color: black"
            >Username sent to the registered mobile number.</span
          >
          <br />
          {{ obscuredMobile }}
          <br />
          <v-btn
            style="margin-top: 20px; width: 100%"
            id="submit"
            @click="
              usernameRecoverySuccessful = false;
              close('forgot-username');
            "
            >OK</v-btn
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span style="font-size: 12px">Didn't recieve the message?</span>
          <v-btn
            x-small
            color="blue darken-1"
            text
            @click="recover('username', nasid)"
            style="text-transform: capitalize"
            >Resend</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="passwordRecoverySuccessful" persistent max-width="320">
      <v-card style="padding-top: 100px">
        <v-card-text style="text-align: center">
          <span style="font-weight: bold; font-size: 18px; color: black"
            >Temporary password sent to the registered mobile number.</span
          >
          <br />
          {{ obscuredMobile }}
          <br />
          <v-btn
            style="margin-top: 20px; width: 100%"
            id="submit"
            @click="
              passwordRecoverySuccessful = false;
              close('forgot-password');
            "
            >OK</v-btn
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span style="font-size: 12px">Didn't recieve the message?</span>
          <v-btn
            x-small
            color="blue darken-1"
            text
            @click="recover('resend-password', username)"
            style="text-transform: capitalize"
            >Resend</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ChangePassword
      v-bind:showChangePassword="changePassword"
      v-bind:userData="userData"
      @updated-password="passwordUpdated($event)"
    ></ChangePassword>
  </v-container>
</template>

<script>
import axios from "./../../plugins/axios";
import helper from "./../../utils/helper";
import ChangePassword from "./../common/password/ChangePassword";

export default {
  name: "Login",
  props: ["toRelogin"],
  components: { ChangePassword },
  data: function () {
    return {
      nasid: null,
      username: null,
      showPass: false,
      userName: "",
      password: "",
      userId: 0,
      userData: null,
      loginUser: true,
      forgotUsername: false,
      forgotPassword: false,
      usernameRecoverySuccessful: false,
      passwordRecoverySuccessful: false,
      obscuredMobile: "XXXXX-XXXXX",
      changePassword: false,
    };
  },
  methods: {
    clear: function () {
      this.userName = "";
      this.password = "";
    },
    LoginUser: function (userName = "", password = "") {
      if (userName == "" && password == "") {
        alert("Please enter a Username and a Password");
        return;
      } else {
        if (userName == "") {
          alert("Please enter a Username");
          return;
        } else {
          if (password == "") {
            alert("Please enter a Password");
            return;
          }
        }
      }
      axios
        .get(
          "/WiomDashboard/LoginWeb?username=" +
            userName +
            "&password=" +
            password +
            "&authType=CUSTOM"
        )
        .then((response) => {
          //console.log(response);
          if (response.data.status == 0) {
            let user = response.data.data;
            this.userData = user;
            this.userId = user.userid;
            try {
              if (user.is_password_temporary == true) {
                this.changePassword = true;
              } else {
                helper.setCookie("token", user.token.token, 7);
                helper.setCookie("userData", JSON.stringify(this.userData), 7);
                helper.setCookie("loggedIn", true, 7);
                //console.log("signing in");
                this.$emit("sign-in", this.userData);
              }
            } catch (ex) {
              //console.log("Error storing userdata" + ex);
            }
          } else {
            alert(
              "Incorrect Username or Password. Please enter a valid Username and Password combination."
            );
          }
        });
    },
    CheckLogin: function () {
      try {
        var userDataString = helper.getCookie("userData");
        var userData = JSON.parse(userDataString);
        this.LoginUser(userData.email, userData.password);
      } catch (ex) {
        // Do nothing, the user will have to login now
        //console.log("Please Login in Sir!");
      }
    },
    passwordUpdated: function (newPassword) {
      this.changePassword = false;
      this.LoginUser(this.userData.username, newPassword);
    },
    show: function (what) {
      switch (what) {
        case "forgot-username":
          this.forgotUsername = true;
          this.loginUser = false;
          break;
        case "forgot-password":
          this.forgotPassword = true;
          this.loginUser = false;
          break;
      }
    },
    close: function (what) {
      switch (what) {
        case "forgot-username":
          this.forgotUsername = false;
          this.loginUser = true;
          break;
        case "forgot-password":
          this.forgotPassword = false;
          this.loginUser = true;
          break;
      }
    },
    recover: function (what, data = null) {
      switch (what) {
        case "username":
          axios.get("/wiom/RecoverUsername?nasid=" + data).then((response) => {
            if (response.data.msg == "SUCCESS") {
              console.log("SUCCESS", response.data);
              this.obscuredMobile = response.data.data;
              this.usernameRecoverySuccessful = true;
            } else {
              console.log("ERROR", response.data);
              alert("Error. Please try again later.");
            }
          });
          break;
        case "password":
          axios
            .get("/wiom/RecoverPassword?resend=false&username=" + data)
            .then((response) => {
              if (response.data.msg == "SUCCESS") {
                console.log("SUCCESS", response.data);
                this.obscuredMobile = response.data.data;
                this.passwordRecoverySuccessful = true;
              } else {
                console.log("ERROR", response.data);
                alert("Error. Please try again later.");
              }
            });
          break;
        case "resend-password":
          axios
            .get("/wiom/RecoverPassword?resend=true&username=" + data)
            .then((response) => {
              if (response.data.msg == "SUCCESS") {
                console.log("SUCCESS", response.data);
                this.obscuredMobile = response.data.data;
                this.passwordRecoverySuccessful = true;
              } else {
                console.log("ERROR", response.data);
                alert("Error. Please try again later.");
              }
            });
          break;
      }
    },
  },
  mounted: function () {
    this.CheckLogin();
  },
  watch: {
    toRelogin: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.username != null && newValue.password != null) {
          console.log("Logging In Again", newValue);
          this.LoginUser(newValue.username, newValue.password);
        }
      }
    }
  }
};
</script>
